export const CONFIG_DEV = {
  NAME: "DEV",
  BASE_URL: `https://api-dev.bicyclebluebook.com`,
  WEB_URL: `http://localhost:8080`,
};
